module.exports = __webpack_public_path__ + "static/fonts/Inter_24pt-Bold.8b04b3bd.ttf";